var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6658 3.0625C12.1345 2.71094 12.5564 2.28906 12.8845 1.79688C12.4626 1.98438 11.9705 2.125 11.4783 2.17188C11.9939 1.86719 12.3689 1.39844 12.5564 0.8125C12.0876 1.09375 11.5486 1.30469 11.0095 1.42188C10.5408 0.929688 9.90796 0.648438 9.20483 0.648438C7.84546 0.648438 6.7439 1.75 6.7439 3.10938C6.7439 3.29688 6.76733 3.48438 6.81421 3.67188C4.77515 3.55469 2.94702 2.57031 1.72827 1.09375C1.51733 1.44531 1.40015 1.86719 1.40015 2.33594C1.40015 3.17969 1.82202 3.92969 2.50171 4.375C2.10327 4.35156 1.70483 4.25781 1.37671 4.07031V4.09375C1.37671 5.28906 2.22046 6.27344 3.34546 6.50781C3.15796 6.55469 2.92358 6.60156 2.71265 6.60156C2.54858 6.60156 2.40796 6.57812 2.2439 6.55469C2.54858 7.53906 3.46265 8.24219 4.54077 8.26562C3.69702 8.92188 2.64233 9.32031 1.4939 9.32031C1.28296 9.32031 1.09546 9.29688 0.907959 9.27344C1.98608 9.97656 3.27515 10.375 4.6814 10.375C9.20483 10.375 11.6658 6.64844 11.6658 3.39062C11.6658 3.27344 11.6658 3.17969 11.6658 3.0625Z",
    fill: "#1D9CEB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7bc4a9b922bb4586d58e1178d54fd353.svg";
export { ForwardRef as ReactComponent };